import { render } from "./update-information.vue?vue&type=template&id=531d8882&scoped=true&ts=true"
import script from "./update-information.vue?vue&type=script&lang=ts"
export * from "./update-information.vue?vue&type=script&lang=ts"

import "./update-information.vue?vue&type=style&index=0&id=531d8882&scoped=true&lang=scss"

import exportComponent from "/Applications/MAMP/htdocs/wrf.com/wrf-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531d8882"]])

export default __exports__